module.exports = __webpack_public_path__ + "media/images/phone_screen-99df744f4f260921597603cc3ee9ac31.png";